import React, { useMemo } from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useDroplistCache } from "hooks/useDroplistCache";
import useDevice from "hooks/useDevice";

export default function SelectField({
  uuidRef,
  getOption = (op) => op,
  onChange,
  answer,
  fieldValue,
  label,
  ...props
}) {
  const { isMobile } = useDevice();
  const options = useDroplistCache(uuidRef);

  const value = useMemo(() => {
    if (!answer?.answerText) return fieldValue?.text ?? "";
    return answer.answerText ? answer.answerText : "";
  }, [answer.answerText, fieldValue]);

  return (
    <FormControl
      fullWidth
      sx={{ minWidth: isMobile ? "100%" : "180px", marginBottom: "16px" }}
    >
      {label && (
        <InputLabel
          sx={{
            transform: "translate(14px, 10px) scale(1)",
            "&.MuiInputLabel-shrink": {
              transform: "translate(14px, -9px) scale(0.75) !important",
            },
          }}
          id={`${uuidRef}-label`}
        >
          {label}
        </InputLabel>
      )}
      <Select
        value={value}
        onChange={onChange}
        label={label}
        labelId={`${uuidRef}-label`}
        renderValue={(selected) => {
          if (answer?.answerText) return answer.answerText;
          const found = options.find((opt) => opt.uuid === selected);
          return found?.title || "";
        }}
        {...props}
      >
        {options.map((item) => (
          <MenuItem key={item.uuid} value={item.uuid || ""}>
            {item.title}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
